<div class="reports-page">
	<div *ngIf="loading">Loading...</div>
	<div *ngIf="error" class="error">{{ error }}</div>

	<div class="section mb-3">
		<div class="card app-card">
			<div class="card-body">
				<div class="page-header">
					<h1 class="page-title">Summary</h1>
				</div>

				<div class="mb-3 row align-items-center">
					<label class="col-sm-2 col-form-label">Select Month</label>
					<div class="col-sm-4">
						<nz-date-picker class="w-100" nzMode="month" [(ngModel)]="month"
							[nzDisabledDate]="disabledDate" (ngModelChange)="onMonthSelected($event)"></nz-date-picker>
					</div>
				</div>

				<app-table
					[downloadHeading]="'Report List'"
					[downloadName]="'report_list'"
					[data]="data" [columns]="columns" [loading]="loading" [disablePaging]="true"
					[headerClass]="'table-info'" [boldLastRow]="true">
				</app-table>
			</div>
		</div>
	</div>

</div>
